import { Typography } from '@mui/material';
import clsx from 'clsx';
import { createElement, isValidElement, useMemo } from 'react';
import _ from 'lodash';
import WdSvgIcon from '../../core/WdSvgIcon';

/**
 * TextWithLabel
 *
 * Componente para mostrar un texto con título e ícono opcional, en formato de bloque.
 *
 * @component
 * @param {React.ReactNode} children - Contenido principal a mostrar
 * @param {React.ReactNode|string} [icon] - Ícono a mostrar antes del título
 * @param {string} title - Título a mostrar
 * @param {string} [childrenClasses] - Clases CSS adicionales para el contenido
 * @param {string} [titleClasses] - Clases CSS adicionales para el título
 * @param {string} [className] - Clases CSS adicionales para el contenedor
 * @param disableChildrenBold
 * @param props
 * @returns {JSX.Element}
 */
export const TextWithLabel = ({
  children,
  icon,
  title,
  childrenClasses,
  titleClasses,
  className,
  disableChildrenBold = false,
  ...props
}) => {
  const memoizedChildren = useMemo(() => {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (!children) return <></>;
    if (!_.isString(children) && !_.isNumber(children)) return children;
    return (
      <Typography
        className={clsx('text-slate-300', !disableChildrenBold ? 'text-xl' : '', childrenClasses)}
        // gutterBottom
      >
        {children}
      </Typography>
    );
  }, [children, childrenClasses, disableChildrenBold]);

  return (
    <div {...props} className={clsx('mb-16', className)}>
      <Typography
        className={clsx(
          'text-slate-300 text-base font-light text-ellipsis line-clamp-2',
          titleClasses
        )}
        gutterBottom
      >
        {icon && typeof icon === 'string' && (
          <WdSvgIcon color="disabled" size={20}>
            {icon}
          </WdSvgIcon>
        )}
        {icon && isValidElement(icon) && createElement(icon.type, { ...icon.props })}
        <span className="mr-4">{title}</span>
      </Typography>
      {memoizedChildren}
    </div>
  );
};
